import { render, staticRenderFns } from "./BtnDispatchOverpack.vue?vue&type=template&id=086ac51b&scoped=true&"
import script from "./BtnDispatchOverpack.vue?vue&type=script&lang=js&"
export * from "./BtnDispatchOverpack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ac51b",
  null
  
)

export default component.exports